import { PreInterviewForm } from '../shared/form/PreInterviewForm';

export const PreInterviewCreateForm = PreInterviewForm;
